import { useHistory } from 'react-router'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { isEmpty, sortBy } from 'lodash'
import Fuse from 'fuse.js'

import Loader from 'components/Loader'
import PendingRefundsMobile from 'components/PendingRefundsList/List/PendingRefundsMobile'
import PendingRefundsDesktop from 'components/PendingRefundsList/List/PendingRefundsDesktop'

import {
  getFilteredRefundOrders,
  getIsLoadingRefundOrders,
  getRefundOrdersSearchQueryValue,
} from 'store/Orders/selector'
import { FUSE_OPTIONS } from 'utils/fuseSettings'

const PendingRefundsList = () => {
  const history = useHistory()
  const { uuid: pendingRefundUuid } = useParams()

  const filteredRefundOrders = useSelector(getFilteredRefundOrders)
  const isLoadingPendingRefunds = useSelector(getIsLoadingRefundOrders)
  const refundOrdersSearchQuery = useSelector(getRefundOrdersSearchQueryValue)

  const options = {
    ...FUSE_OPTIONS,
    keys: ['submissionResult.confirmationNumber'],
  }

  const isModal = !isEmpty(pendingRefundUuid)
  const isLoading = isLoadingPendingRefunds && !isModal

  const orders = isEmpty(refundOrdersSearchQuery)
    ? filteredRefundOrders
    : new Fuse(filteredRefundOrders, options)
        .search(refundOrdersSearchQuery)
        .map((item) => item.item)

  const sortedPendingRefunds = sortBy(orders, 'name')

  const onClickPendingRefund = (uuid) => () => {
    history.push(`pending-refunds/${uuid}/refund`)
  }

  if (isLoading) {
    return <Loader />
  } else {
    return (
      <>
        <PendingRefundsMobile
          pedningRefunds={sortedPendingRefunds}
          onClickPendingRefund={onClickPendingRefund}
        />
        <PendingRefundsDesktop
          pedningRefunds={sortedPendingRefunds}
          onClickPendingRefund={onClickPendingRefund}
        />
      </>
    )
  }
}

export default PendingRefundsList
